export const messageEditSessionKey = ({
  threadUuid,
  messageId,
  messageIndex,
} = {}) => JSON.stringify([
  threadUuid ?? null,
  messageId ?? null,
  Number.isInteger(messageIndex) ? messageIndex : null,
]);

export const shouldPlaceMessageEditCaret = ({
  sessionKey,
  placedSessionKey,
  draft,
  initialText,
} = {}) => (
  Boolean(sessionKey) &&
  sessionKey !== placedSessionKey &&
  draft === initialText
);
